export async function parseTextResult(response) {
    const text = await response.text()
    return text && response.status !== 401 ? JSON.parse(text) : undefined
}
